declare var gtag: any;

type EventParameter = {
  category: string;
  action: string;
  label: string;
  nonInteraction?: boolean;
};

export default class Base {
  sendEvent({ category, action, label, nonInteraction = true }: EventParameter) {
    if ('gtag' in window) {
      gtag('event', action, {
        event_category: category,
        event_label: label,
        non_interaction: nonInteraction, // 直帰率に影響を与えたくない場合はtrueにする
      });
    } else {
      console.info(JSON.stringify({ category, action, label, nonInteraction }, null, '\t'));
      console.info('gtagが読み込まれていません。');
    }
  }
}
